import request from '@/utils/request'

const login = (username, password) => {
  return request({
    url: '/api/login',
    method: 'post',
    data: {
      username: username,
      password: password
    }
  })
}

export default {
  login
}
